// extracted by mini-css-extract-plugin
export default {"rootNoMargin":"OptionsList_rootNoMargin__SqmfX","option":"OptionsList_option__fwE7m","icon":"OptionsList_icon__1mub2","input":"OptionsList_input__5PuzB"};